import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { initializeMsal } from './config/authConfig'
import { initTelemetry, trackException, ExceptionPhase, ExceptionProp } from './observability'
import { ObservabilityErrorBoundary } from './observability/errorBoundary'

import { FluentProvider, webLightTheme } from '@fluentui/react-components';

// Safe to call before MSAL resolves — each tool no-ops if its env var is unset
initTelemetry();

// Initialize MSAL before rendering the app
initializeMsal().then(() => {
    ReactDOM.createRoot(document.getElementById('root')!).render(
        <React.StrictMode>
            <ObservabilityErrorBoundary>
                <FluentProvider theme={webLightTheme}>
                    <App />
                </FluentProvider>
            </ObservabilityErrorBoundary>
        </React.StrictMode>,
    )
}).catch((error) => {
    console.error('Failed to initialize MSAL:', error);
    trackException(error, { [ExceptionProp.Phase]: ExceptionPhase.MsalInit });
    // Show error UI if needed
    document.getElementById('root')!.innerHTML = `
        <div style="display: flex; align-items: center; justify-center; height: 100vh; font-family: system-ui;">
            <div style="text-align: center; padding: 20px;">
                <h1 style="color: #dc2626;">Authentication Error</h1>
                <p>Failed to initialize authentication system. Please refresh the page.</p>
            </div>
        </div>
    `;
});

